import {Component, Input} from '@angular/core';
import {QuestionBase} from '../../domain/question.base';

@Component({
  selector: 'crds-form-error',
  templateUrl: './form-error.component.html'
})
export class FormErrorComponent {
  @Input() message: string;
  @Input() question: QuestionBase<any>;
}
